// extracted by mini-css-extract-plugin
export default {"EmptyState":"EmptyStateMyPostulations_EmptyState__ulNcW"};